/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable no-unreachable */
/* eslint-disable spaced-comment */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import queryService from '../../../redux/services/queryServices';
import companyServices from '../../../redux/services/companyServices';
import companyActions from '../../../redux/actions/companyActions';

//  Ordre du dropdown :
//    Company
//    Group
//    Users
//    Module
//    Parcours
//    Resources

const getDataSearchBar = (inputValue, callback) => {
  if (inputValue.length > 1) {
    const inputValueLowercase = inputValue.toLowerCase();
    queryService.queryByString(inputValueLowercase)
      .then((data) => {
        if (data.user) {
          const UserConcatLastnameFirstname = data.user;
          UserConcatLastnameFirstname.map((elem) => elem);
        }

        const tempArray = [];
        data.company?.forEach((element) => {
          tempArray.push({ label: element.name, value: element._id, modeltype: 'Company' });
        });

        data.user?.forEach((element) => {
          tempArray.push({
            label: element.name, value: element._id, email: element.email, modeltype: 'Student',
          });
        });

        data.customer?.forEach((element) => {
          tempArray.push({
            label: element.name, value: element._id, email: element.email, modeltype: 'Customer',
          });
        });

        data.teacher?.forEach((element) => {
          tempArray.push({
            label: element.name, value: element._id, email: element.email, modeltype: 'Teacher',
          });
        });

        callback(tempArray);
      });
  }
};

const TopbarSearchbar = (props) => {
  const [redirectionPage, setredirectionPage] = useState(false);
  const [selectedItem, setselectedItem] = useState(null);
  const [redirectItem, setRedirectItem] = useState(null);
  const [input, setinput] = useState('');

  const getRedirection = () => {
    if (selectedItem) {
      if (selectedItem.modeltype === 'Company') {
        return (
          <Redirect
            to={{
              pathname: `/company/test/${selectedItem._id}`,
            }}
          />
        );
      } if (selectedItem.modeltype === 'Group') {
        return (
          <Redirect
            to={{
              pathname: `/search/Group/${selectedItem._id}`,
            }}
          />
        );
      } if (selectedItem.modeltype === 'Student') {
        return (
          <Redirect
            to={{
              pathname: `/search/Student/${selectedItem.email}`,
            }}
          />
        );
      } if (selectedItem.modeltype === 'Customer') {
        return (
          <Redirect
            to={{
              pathname: `/search/Customer/${selectedItem.email}`,
            }}
          />
        );
      } if (selectedItem.modeltype === 'Teacher') {
        return (
          <Redirect
            to={{
              pathname: `/search/teachers/${selectedItem.email}`,
            }}
          />
        );
      } if (selectedItem.modeltype === 'Course') {
        return (
          <Redirect
            to={{
              pathname: '/search/Course',
            }}
          />
        );
      } if (selectedItem.modeltype === 'Module') {
        return (
          <Redirect
            to={{
              pathname: '/search/Module',
            }}
          />
        );
      } if (selectedItem.modeltype === 'Resource') {
        return (
          <Redirect
            to={{
              pathname: `/search/Resource/${selectedItem.label}`,
            }}
          />
        );
      }
    } else {
      return (<div />);
    }
  };

  const handlerChange = (element) => {
    if (element.modeltype === 'Company') {
      companyServices.getCompanyById(element.value)
        .then((res) => {
          setinput(null);
          res.modeltype = 'Company';
          props.setCompany(res);
          setselectedItem(res);
          setredirectionPage(true);
          window.location.href = `/company/test/${element.value}`;
        });
    } else if (element.modeltype === 'Group') {
      companyServices.getCompanyBygroupId(element.value)
        .then((res) => {
          setinput(null);
          res.modeltype = 'Group';
          props.setCompany(res);
          setselectedItem(res);
          setredirectionPage(true);
        });
    } else {
      setinput(null);
      setredirectionPage(true);
      setselectedItem(element);
    }
  };

  useEffect(() => {
    setRedirectItem(getRedirection());
  }, [selectedItem, redirectionPage]);

  useEffect(() => {
    if (input) {
      setRedirectItem(null);
    }
  }, [input]);

  return (
    <div>
      <AsyncSelect
        autoFocus
        noOptionsMessage={() => 'Nothing Found'}
        placeholder="Look for a client, a group, a student, a teacher, a customer or a resource."
        loadOptions={getDataSearchBar}
        value={input || ''}
        onInputChange={(inr) => { setinput(inr); }}
        onChange={handlerChange}
        debounceTimeout={500}
      />
      { redirectItem }
    </div>
  );
};

function mapState(state) {
  const { sidebar } = state;
  return { sidebar };
}

const actionCreators = {
  setCompany: companyActions.setCompany,
  unsetCompany: companyActions.unsetCompany,
};

export default withRouter(connect(mapState, actionCreators)(TopbarSearchbar));
